angular.module("questionarioAdv.module")
  .component("fiducianti", {
    templateUrl: "ng/components/questionarioAdv/fiducianti/fiducianti.view.html",
    bindings: {
      model: "=",
      exportValidationComponent: '&',
      newFiduciarioAddFn: '&',
      domini: '<',
      resetSupportModel: '<',
      startQuestionario: '<',
      isPagoDopo: '<',
      showHideFiducianti: '<',
      listaNazioni: '<',
      submitError: '<',
      externalLink: '<'
    },
    controllerAs: 'fiduciantiCtrl',
    controller: Fiducianti
  })

function Fiducianti(
  $istatService,
  $rootScope,
  $typeDomainService,
  $scope,
  Documento,
  $timeout,
  $configService,
  Sede,
  $storageService,
  validationService,
  $financialApiService,
  $modalService,
  FileUploader,
  $simulationService,
  $userService,
  $portalService,
  Pf,
  $instantService,
  $uniService,
  $download
) {
  var self = this;

  self.$onInit = function () {
    self.isAru = $portalService.isAru();
    self.dealerUser = {};
    self.mapComuni = $rootScope.comuniMap;
    self.documentUpload = [];
    self.testDati = [];
    self.listaNomeComuniRilascio = [];
    self.listaNomeComuniRilascioNew = [];
    self.uploadDocumentSelect = "upload"
    self.linkPep = '/uni/download/service-infos/' +
      encodeURIComponent('GLOSSARIO') + '/';
    self.validationObj = {
      documentDate: {
        disabledDays: [0],
        disabledDates: [
          "01-01",
          "06-01",
          "25-04",
          "01-05",
          "02-06",
          "15-08",
          "01-11",
          "08-12",
          "25-12",
          "26-12"
        ]
      }
    };
    self.cfIsNotRequired = [];
    self.listaNomeRilascio = [];
    self.listaNomeRilascioNew = [];
    self.listaComuniNascita = [];
    self.newFiduciariAdded = []
    self.today = self.getTodaysDate();
    self.model && self.model.forEach(function (element, index) {
      if (element && !element.documento) {
        element.documento = Documento.build();
      }
      self.listaNomeRilascio[index] = element.documento && element.documento.tipo && Documento.getEntiRilascio(
        element.documento.tipo
      );
      if (element && element.sedeLegale && element.sedeLegale.stato) {
        element.sedeLegale.stato.name = element.sedeLegale.stato.name && element.sedeLegale.stato.name.toUpperCase();
      }
      self.creaComuni(index, element.documento.provincia);
    })
    self.dropdown = {
      tipiDocumento: []
    }
    self.tomorrow = moment()
      .add(1, "days")
      .format("DD/MM/YYYY");
    self.supportModel = {
      ruolo: [],
      caricaIstituzionale: [],
      relazionePep: [],
      originePatrimonio: []
    }
    self.supportNewFiduciarioAdded = {
      ruolo: [],
      caricaIstituzionale: [],
      relazionePep: [],
      originePatrimonio: []
    }
    if (!self.model) {
      self.model = [];
    }
    getListaProvince();
    //getListNazioni();
    getListaDocumenti();
    setDefaulValue();
    validateComponent();

    $timeout(function () {
      self.validatingComponent();
    }, 200)
  }

  self.downloadLinkPep = () => {

    $download.getGenericDownload(self.linkPep)
      .then(function (response) {
        console.log(response);
      })
  }

  self.$onChanges = function (changed) {
    if (changed && changed.resetSupportModel && typeof changed.resetSupportModel.currentValue != "undefined") {
      self.newFiduciariAdded = [];
    }
    if (changed && changed.listaNazioni && changed.listaNazioni.currentValue) {
      self.nationCitizenship = self.listaNazioni.filter(
        function (element) {
          return !element.deleted
        }).map(function (element) {
          return element.name.toUpperCase();
        }).sort();
    }

    if (changed && changed.submitError && typeof changed.submitError.currentValue != "undefined") {
      ricreaModelli();
    }
  }

  self.handleChange = function (tipo, subType, valueSelected, indice, tipologia) {
    if (tipologia === 'fiduciarioAdded') {
      if (subType) {
        self.newFiduciariAdded[indice][tipo][subType].forEach(function (element) {
          if (element.value == valueSelected.value) {
            element.selected = true;
          } else {
            element.selected = false;
          }
        })

      } else {
        self.newFiduciariAdded[indice][tipo].forEach(function (element) {
          if (element.value == valueSelected.value) {
            element.selected = true;
          } else {
            element.selected = false;
          }
        })
      }
    } else {
      if (subType) {
        self.model[indice][tipo][subType].forEach(function (element) {
          if (element.value == valueSelected.value) {
            element.selected = true;
          } else {
            element.selected = false;
          }
        })
      } else {
        self.model[indice][tipo].forEach(function (element) {
          if (element.value == valueSelected.value) {
            element.selected = true;
          } else {
            element.selected = false;
          }
        })
      }
    }
    validateComponent();
  }

  var getListaDocumenti = function () {

    $typeDomainService
      .getDomainSet("RI_DROPDOWN_DOMAINS", "DOCUMENT_TYPE")
      .then(function (response) {
        self.dropdown.tipiDocumento = response.domainList;
        for (i = 0; i < self.dropdown.tipiDocumento.length; i++) {
          if (self.dropdown.tipiDocumento[i].value == "CAE") {
            self.dropdown.tipiDocumento[i].order = 40;
          }
          if (self.dropdown.tipiDocumento[i].value == "CAI") {
            self.dropdown.tipiDocumento[i].order = 10;
          }
          if (self.dropdown.tipiDocumento[i].value == "CIE") {
            self.dropdown.tipiDocumento[i].order = 20;
          }
          if (self.dropdown.tipiDocumento[i].value == "NCE") {
            self.dropdown.tipiDocumento[i].order = 30;
          }
          if (self.dropdown.tipiDocumento[i].value == "PAM") {
            self.dropdown.tipiDocumento[i].order = 50;
          }
          if (self.dropdown.tipiDocumento[i].value == "PAS") {
            self.dropdown.tipiDocumento[i].order = 80;
          }
          if (self.dropdown.tipiDocumento[i].value == "PAT") {
            self.dropdown.tipiDocumento[i].order = 60;
          }
          if (self.dropdown.tipiDocumento[i].value == "UCO") {
            self.dropdown.tipiDocumento[i].order = 70;
          }

        }
      });
  }


  self.getTodaysDate = function () {

    return moment().format("DD/MM/YYYY");
  }

  self.setDocNumRegex = function (indice, tipo) {

    if (tipo === 'fiduciarioAdded') {
      self.listaNomeRilascioNew[indice] = Documento.getEntiRilascio(
        self.newFiduciariAdded[indice].documento.tipo
      );
      self.newFiduciariAdded[indice].documento.numero = null;
    } else {
      self.listaNomeRilascio[indice] = Documento.getEntiRilascio(
        self.model[indice].documento.tipo
      );
      self.model[indice].documento.numero = null;

    }
    $timeout(function () {
      self.refreshRegex = false;
      validateComponent();
    }, 200)

    if (tipo === 'fiduciarioAdded' && self.newFiduciariAdded[indice].ndg && !self.isPagoDopo) {
      $financialApiService
        .getIdentityDocument(
          self.newFiduciariAdded[indice].ndg,
          self.newFiduciariAdded[indice].documento.tipo
        )
        .then(function (response) {
          if (response.success) {
            self.newFiduciariAdded[indice].documento.dataRilascio =
              response.document.dataRilascio;
            self.newFiduciariAdded[indice].documento.dataScadenza =
              response.document.dataScadenza;
            self.newFiduciariAdded[indice].documento.luogoEsteso = {
              nome: response.document.luogo,
            };
            self.newFiduciariAdded[indice].documento.enteRilascio.name =
              response.document.enteRilascio;
            self.newFiduciariAdded[indice].documento.provincia =
              response.document.provincia;
            self.newFiduciariAdded[indice].documento.numero = response.document.numero;
            self.newFiduciariAdded[indice].documento.id = response.document.id;
          }
          $timeout(function () {
            validateComponent();
          }, 1000)
        })
        .catch(function (error) {
          console.log(error);
        });

    } else if (self.model && self.model[indice] && self.model[indice].ndg && tipo != 'fiduciarioAdded' && !self.isPagoDopo) {
      $financialApiService
        .getIdentityDocument(
          self.model[indice].ndg,
          self.model[indice].documento.tipo
        )
        .then(function (response) {
          if (response.success) {
            self.model[indice].documento = Documento.build({
              tipo: self.model[indice].documento.tipo
            })
            self.model[indice].documento.dataRilascio =
              response.document.dataRilascio;
            self.model[indice].documento.dataScadenza =
              response.document.dataScadenza;
            self.model[indice].documento.luogoEsteso = {
              nome: response.document.luogo,
            };
            self.model[indice].documento.enteRilascio.name =
              response.document.enteRilascio;
            self.model[indice].documento.provincia =
              response.document.provincia;
            self.model[indice].documento.numero = response.document.numero;
            self.model[indice].documento.id = response.document.id;
          }
          $timeout(function () {
            validateComponent();
          }, 1000)
        })
        .catch(function (error) {
          console.log(error);
        });
    } else {
      switch (tipo) {
        case 'fiduciarioAdded':
          self.newFiduciariAdded[indice].documento = Documento.build({
            tipo: self.newFiduciariAdded[indice].documento.tipo
          });
          break;
        default:
          self.model[indice].documento = Documento.build({
            tipo: self.model[indice].documento.tipo
          });
      }
    }
  }

  var getListaProvince = function () {
    self.listaProvince = self.mapComuni
      .map(function (comune) {
        return comune.sigla;
      })
      .filter(function (siglaComune) {
        return siglaComune != "";
      })
      .sort()
      .reduce(function (result, nextItem) {
        return result.includes(nextItem) ? result : result.concat(nextItem);
      }, []);
    self.listaProvince.push("EE");

  }

  self.creaComuni = function (indice, provincia, isNewModel) {
    if (isNewModel) {
      if (provincia != 'EE') {
        self.listaNomeComuniRilascioNew[indice] = self.mapComuni
          .filter(function (comune) {
            return comune.sigla == provincia;
          });
      }

    } else {
      if (provincia != 'EE') {
        self.listaNomeComuniRilascio[indice] = self.mapComuni
          .filter(function (comune) {
            return comune.sigla == provincia;
          });
      }
    }
    validateComponent();
  }

  var getListNazioni = function () {
    $istatService.getNazioni()
      .then(function (response) {
        self.listaNazioni = response.domainList.filter(
          function (element) {
            return !element.deleted
          });
        self.nationCitizenship = response.domainList.filter(
          function (element) {
            return !element.deleted
          }).map(function (element) {
            return element.name.toUpperCase();
          }).sort();
      })
  }

  self.radioModify = function (tipo, valore, indice) {
    if (tipo == 'pep') {
      if (!valore) {
        self.supportModel.caricaIstituzionale[indice] = null;
        self.supportModel.relazionePep[indice] = null;
      }

      self.model[indice].pep.carica.forEach(function (element) {
        element.selected = false;
      })

      self.model[indice].pep.relazione.forEach(function (element) {
        element.selected = false;
      })
    } else if (tipo == 'domicilioDiverso') {
      self.model[indice].domicilioDiverso = valore;
    }
    validateComponent();
  }

  self.radioModifyNewFiduciante = function (tipo, valore, indice) {
    if (tipo == 'pep') {
      if (!valore) {
        self.supportNewFiduciarioAdded.caricaIstituzionale[indice] = null;
        self.supportNewFiduciarioAdded.relazionePep[indice] = null;
      }

      self.newFiduciariAdded[indice].pep.carica.forEach(function (element) {
        element.selected = false;
      })

      self.newFiduciariAdded[indice].pep.relazione.forEach(function (element) {
        element.selected = false;
      })
    }
    validateComponent();
  }

  var validateComponent = function () {
    $timeout(function () {

      var checkFileIsUploadedModel = self.model.every(function (element) {
        return (element.documento &&
          element.documento.idImgDocumentoFront) ||
          element.annullato ||
          element.annullatoFe
      })

      var checkFileIsUploadedNewFiduciario = self.newFiduciariAdded.every(function (element) {
        return element.documento && element.documento.idImgDocumentoFront
      })

      var testSesso = self.newFiduciariAdded.filter(function (element) {
        return !!!element.cf
      }).every(function (sex) {
        return sex.sesso != null;
      })
      var permissionIsPresent = $storageService.getAppConfig().allFunctionalities.includes("ADV_FULL");
      var leastOne = true;
      if (self.showHideFiducianti && permissionIsPresent) {
        leastOne = self.model.length > 0 || self.newFiduciariAdded.length > 0;
      }

      var testComponentValid = $scope.fiducianteForm.$valid &&
        checkFileIsUploadedModel &&
        checkFileIsUploadedNewFiduciario &&
        testSesso &&
        leastOne;
      console.log("Il form fiducianti è:", testComponentValid);

      self.newFiduciarioAddFn({
        nuovoFiduciante: self.newFiduciariAdded
      })


      self.exportValidationComponent({
        valid: testComponentValid
      })

    }, 500)
  }


  self.handleChangeClassicVersion = function (name, value, indice) {
    console.log(name)
    switch (name) {
      case 'number-document':
        self.model[indice].documento.numero = value
        break;

      case 'dataScadenza':
        self.model[indice].documento.dataScadenza = value;
        break;

      case 'dataRilascio':
        self.model[indice].documento.dataRilascio = value;
        break;

      default:
        if (typeof indice != 'undefined' && !!name) {
          self.model[indice][name] = value;
        }
        break;
    }
    validateComponent();
  }

  self.handleChangeClassicVersionNewFiduciario = function (name, value, indice) {
    console.log(name)
    switch (name) {
      case 'number-document':
        self.newFiduciariAdded[indice].documento.numero = value
        break;

      case 'dataScadenza':
        self.newFiduciariAdded[indice].documento.dataScadenza = value;
        break;

      case 'dataRilascio':
        self.newFiduciariAdded[indice].documento.dataRilascio = value;
        break;

      default:
        if (name) {
          self.newFiduciariAdded[indice][name] = value;
        }
        break;
    }
    validateComponent();
  }

  self.addFiduciario = function () {
    var newFiducianti = createNewFiduciario();
    self.newFiduciariAdded.push(newFiducianti)
    validateComponent();
  }

  var createNewFiduciario = function (dateOfRest) {
    var newFiducianti = {
      cf: dateOfRest && dateOfRest.cf || null,
      cognome: dateOfRest && dateOfRest.cognome || null,
      data: dateOfRest && dateOfRest.data || null,
      datiNascita: {
        cap: null,
        cittadinanza: dateOfRest && dateOfRest.datiNascita.cittadinanza || null,
        comune: dateOfRest && dateOfRest.datiNascita.comune || null,
        indirizzo: null,
        nazione: dateOfRest && dateOfRest.datiNascita.nazione || null,
        provincia: dateOfRest && dateOfRest.datiNascita.provincia || null
      },
      description: "fiducianti",
      documento: dateOfRest && Documento.build(dateOfRest.documento) || Documento.build(),
      domicilio: dateOfRest && dateOfRest.domicilio || null,
      domicilioDiverso: dateOfRest && dateOfRest.domicilioDiverso || false,
      editable: false,
      id: null,
      ndg: dateOfRest && dateOfRest.ndg || null,
      nome: dateOfRest && dateOfRest.nome || null,
      pep: {
        carica: self.domini.carica,
        origineFondi: self.domini.origineFondi,
        relazione: self.domini.relazione,
        id: "pep_base",
        description: "pep_base",
        visible: false,
        editable: false,
        pep: false,
        origineFondiDescr: null,
        paeseOrigine: null,
        pepFinanziamenti: false,
        relazioneDescr: null
      },
      dataLettera: null,
      ragioneSociale: null,
      sedeLegale: Sede.build(dateOfRest && dateOfRest.sedeLegale),
      visible: false,
      isEstero: dateOfRest && dateOfRest.isEstero
    }
    return newFiducianti;
  }

  self.removeDefault = function (indice) {
    self.model.splice(indice, 1);
    validateComponent();
  }

  self.removeFidciarioAdded = function (indice) {
    self.newFiduciariAdded.splice(indice, 1);
    validateComponent();
  }

  self.verifyDate = function (indice, init) {
    if (!init) {
      if (indice == self.newFiduciariAdded.length - 1 && self.newFiduciariAdded[indice].cf && checkIfFiduciariIsPresent(self.newFiduciariAdded[indice].cf)) {

        return

      }
    }
    var sesso = null;
    if (!self.newFiduciariAdded[indice].cf) {
      sesso = self.newFiduciariAdded[indice].sesso;
    } else {
      var giornoNascita = self.newFiduciariAdded[indice].cf && self.newFiduciariAdded[indice].cf.substring(9, 11);
      sesso = giornoNascita > 40 ? 'F' : 'M'
    }
    var codCat = "";
    if (self.newFiduciariAdded[indice].datiNascita.provincia != 'EE') {
      codCat = self.newFiduciariAdded[indice].datiNascita.comune &&
        self.mapComuni.find(function (element) {
          return element.nome.toUpperCase() == self.newFiduciariAdded[indice].datiNascita.comune.toUpperCase()
        }).codiceCatastale;
    } else {
      codCat = self.listaNazioni.find(function (element) {
        return element.name.toUpperCase() == self.newFiduciariAdded[indice].datiNascita.nazione.toUpperCase();
      }).value
    }
    self.testDati[indice] = validationService.checkCfWithFieds(
      self.newFiduciariAdded[indice].cf,
      self.newFiduciariAdded[indice].nome,
      self.newFiduciariAdded[indice].cognome,
      self.newFiduciariAdded[indice].data,
      sesso,
      codCat
    );
    validateComponent();
  };

  self.setDataNascita = function (indice, value) {
    self.newFiduciariAdded[indice].data = value;
    self.verifyDate(indice);
    validateComponent();
  }

  self.creaComuniNascita = function (indice, provincia) {

    if (self.newFiduciariAdded[indice] && self.newFiduciariAdded[indice].datiNascita && self.newFiduciariAdded[indice].datiNascita.comune) {
      self.newFiduciariAdded[indice].datiNascita.comune = null;
    }

    if (provincia != 'EE') {
      self.listaComuniNascita[indice] = self.mapComuni
        .filter(function (comune) {
          return comune.sigla == provincia;
        });
      if (self.newFiduciariAdded[indice] && self.newFiduciariAdded[indice].datiNascita && self.newFiduciariAdded[indice].datiNascita.nazione) {
        self.newFiduciariAdded[indice].datiNascita.nazione = 'Italia';
      }

    }
    validateComponent();
  }

  self.getEndDate = function (dataRilascio, index, value) {
    if (dataRilascio) {
      var tipoDocumento = self.model[index].documento.tipo;
      var dataNascita = self.model[index].data;
      var dataRilascio = moment(dataRilascio, "DD/MM/YYYY");
      var startYear = moment(dataRilascio).format("YYYY");
      var startDay = moment(dataRilascio).format("DD");
      var startMonth = moment(dataRilascio).format("MM");

      var endDate = moment(dataRilascio)
        .add(10, "years")
        .format("DD/MM/YYYY");

      if (
        tipoDocumento === propMap["DOC_TYPE_CAI"] ||
        tipoDocumento === propMap["DOC_TYPE_NCE"] ||
        tipoDocumento === propMap["DOC_TYPE_CIE"] ||
        tipoDocumento === propMap["DOC_TYPE_CAE"] ||
        tipoDocumento === propMap["DOC_TYPE_PAT"] ||
        tipoDocumento === propMap['DOC_TYPE_PAM'] ||
        tipoDocumento === propMap['DOC_TYPE_UCO'] ||
        self.isM17Map
      ) {
        var dataNascita = moment(dataNascita, "DD/MM/YYYY");
        var birthYear = moment(dataNascita).format("YYYY");
        var birthDay = moment(dataNascita).format("DD");
        var birthMonth = moment(dataNascita).format("MM");

        if (birthMonth == '02' && birthDay == '29') {
          birthMonth = '03';
          birthDay = '01';
        }

        var futureBirthDay = moment(
          birthDay + "/" + birthMonth + "/" + startYear,
          "DD/MM/YYYY"
        )
          .add(10, "years")
          .format("DD/MM/YYYY");
        //console.log("Compleanno Futuro: " + futureBirthDay);

        var daysDiff = moment
          .duration(
            moment(endDate, "DD/MM/YYYY").diff(
              moment(futureBirthDay, "DD/MM/YYYY")
            )
          )
          .asDays();

        var expiryDate;
        if (daysDiff <= 0) {
          expiryDate = moment(futureBirthDay, "DD/MM/YYYY").format(
            "DD/MM/YYYY"
          );
        } else {
          expiryDate = moment(
            birthDay + "/" + birthMonth + "/" + startYear,
            "DD/MM/YYYY"
          )
            .add(11, "years")
            .format("DD/MM/YYYY");
        }

        while (
          (moment(expiryDate, "DD/MM/YYYY").diff(moment(self.today, "DD/MM/YYYY")) <= 0) &&
          ((tipoDocumento === propMap["DOC_TYPE_CAI"]) || (tipoDocumento === propMap["DOC_TYPE_PAT"]))) {
          expiryDate = moment(
            expiryDate,
            "DD/MM/YYYY"
          )
            .add(10, "years")
            .format("DD/MM/YYYY");
        }

        /* aumentiamo l'anno di scadenza di tutti i documenti di 2 anni e 3 mesi vista l'emergenza COVID19 */
        expiryDate = moment(expiryDate, "DD/MM/YYYY")
          .add(2, "years")
          .add(3, "months")
          .format("DD/MM/YYYY");
        //fine campo aggiunto per emergenza COVID19

        if ($scope.fiducianteForm && $scope.fiducianteForm[value] && moment.duration(moment(self.model[index].documento.dataScadenza, "DD/MM/YYYY").diff(moment(expiryDate, "DD/MM/YYYY"))).asDays() > 0) {
          $scope.fiducianteForm[value].$valid = false;
        }
        if ($scope.fiducianteForm && $scope.fiducianteForm[value] && moment.duration(moment(self.model[index].documento.dataScadenza, "DD/MM/YYYY").diff(moment(self.today, "DD/MM/YYYY"))).asDays() < 2) {
          $scope.fiducianteForm[value].$valid = false;
          $scope.fiducianteForm[value].$setValidity("dataScadenza", false);
        } else {
          $scope.fiducianteForm && $scope.fiducianteForm[value] && $scope.fiducianteForm[value].$setValidity("dataScadenza", true);
        }
        return expiryDate;
      } else {
        /* aumentiamo l'anno di scadenza di tutti i documenti di 2 anni e 3 mesi vista l'emergenza COVID19 */
        endDate = moment(endDate, "DD/MM/YYYY")
          .add(2, "years")
          .add(3, "months")
          .format("DD/MM/YYYY");
        //fine campo aggiunto per emergenza COVID19
        if (
          moment
            .duration(
              moment(
                self.model[index].documento.dataScadenza,
                "DD/MM/YYYY"
              ).diff(moment(endDate, "DD/MM/YYYY"))
            )
            .asDays() > 0
        ) {
          $scope.fiducianteForm[value].$valid = false;
        }
        return endDate;
      }
    } else {
      return moment(self.today, "DD/MM/YYYY")
        .add(10, "years")
        .format("DD/MM/YYYY");
    }

  };

  self.getEndDateNewExecut = function (dataRilascio, index, value) {
    if (dataRilascio) {
      var tipoDocumento = self.newFiduciariAdded[index].documento.tipo;
      var dataNascita = self.newFiduciariAdded[index].data;
      var dataRilascio = moment(dataRilascio, "DD/MM/YYYY");
      var startYear = moment(dataRilascio).format("YYYY");
      var startDay = moment(dataRilascio).format("DD");
      var startMonth = moment(dataRilascio).format("MM");

      var endDate = moment(dataRilascio)
        .add(10, "years")
        .format("DD/MM/YYYY");

      if (
        tipoDocumento === propMap["DOC_TYPE_CAI"] ||
        tipoDocumento === propMap["DOC_TYPE_NCE"] ||
        tipoDocumento === propMap["DOC_TYPE_CIE"] ||
        tipoDocumento === propMap["DOC_TYPE_CAE"] ||
        tipoDocumento === propMap["DOC_TYPE_PAT"] ||
        tipoDocumento === propMap['DOC_TYPE_PAM'] ||
        tipoDocumento === propMap['DOC_TYPE_UCO'] ||
        self.isM17Map
      ) {
        var dataNascita = moment(dataNascita, "DD/MM/YYYY");
        var birthYear = moment(dataNascita).format("YYYY");
        var birthDay = moment(dataNascita).format("DD");
        var birthMonth = moment(dataNascita).format("MM");

        if (birthMonth == '02' && birthDay == '29') {
          birthMonth = '03';
          birthDay = '01';
        }

        var futureBirthDay = moment(
          birthDay + "/" + birthMonth + "/" + startYear,
          "DD/MM/YYYY"
        )
          .add(10, "years")
          .format("DD/MM/YYYY");
        //console.log("Compleanno Futuro: " + futureBirthDay);

        var daysDiff = moment
          .duration(
            moment(endDate, "DD/MM/YYYY").diff(
              moment(futureBirthDay, "DD/MM/YYYY")
            )
          )
          .asDays();

        var expiryDate;
        if (daysDiff <= 0) {
          expiryDate = moment(futureBirthDay, "DD/MM/YYYY").format(
            "DD/MM/YYYY"
          );
        } else {
          expiryDate = moment(
            birthDay + "/" + birthMonth + "/" + startYear,
            "DD/MM/YYYY"
          )
            .add(11, "years")
            .format("DD/MM/YYYY");
        }

        while (
          (moment(expiryDate, "DD/MM/YYYY").diff(moment(self.today, "DD/MM/YYYY")) <= 0) &&
          ((tipoDocumento === propMap["DOC_TYPE_CAI"]) || (tipoDocumento === propMap["DOC_TYPE_PAT"]))) {
          expiryDate = moment(
            expiryDate,
            "DD/MM/YYYY"
          )
            .add(10, "years")
            .format("DD/MM/YYYY");
        }

        /* aumentiamo l'anno di scadenza di tutti i documenti di 2 anni e 3 mesi vista l'emergenza COVID19 */
        expiryDate = moment(expiryDate, "DD/MM/YYYY")
          .add(2, "years")
          .add(3, "months")
          .format("DD/MM/YYYY");
        //fine campo aggiunto per emergenza COVID19

        if ($scope.fiducianteForm && $scope.fiducianteForm[value] && moment.duration(moment(self.newFiduciariAdded[index].documento.dataScadenza, "DD/MM/YYYY").diff(moment(expiryDate, "DD/MM/YYYY"))).asDays() > 0) {
          $scope.fiducianteForm[value].$valid = false;
        }
        if ($scope.fiducianteForm && $scope.fiducianteForm[value] && moment.duration(moment(self.newFiduciariAdded[index].documento.dataScadenza, "DD/MM/YYYY").diff(moment(self.today, "DD/MM/YYYY"))).asDays() < 2) {
          $scope.fiducianteForm[value].$valid = false;
          $scope.fiducianteForm[value].$setValidity("dataScadenza", false);
        } else {
          $scope.fiducianteForm && $scope.fiducianteForm[value] && $scope.fiducianteForm[value].$setValidity("dataScadenza", true);
        }
        return expiryDate;
      } else {
        /* aumentiamo l'anno di scadenza di tutti i documenti di 2 anni e 3 mesi vista l'emergenza COVID19 */
        endDate = moment(endDate, "DD/MM/YYYY")
          .add(2, "years")
          .add(3, "months")
          .format("DD/MM/YYYY");
        //fine campo aggiunto per emergenza COVID19
        if (
          moment
            .duration(
              moment(
                self.newFiduciariAdded[index].documento.dataScadenza,
                "DD/MM/YYYY"
              ).diff(moment(endDate, "DD/MM/YYYY"))
            )
            .asDays() > 0
        ) {
          $scope.fiducianteForm[value].$valid = false;
        }
        return endDate;
      }
    } else {
      return moment(self.today, "DD/MM/YYYY")
        .add(10, "years")
        .format("DD/MM/YYYY");
    }

  };

  var setDefaulValue = function () {
    self.model && self.model.forEach(function (element, index) {
      self.supportModel.caricaIstituzionale[index] = element.pep && element.pep.carica.find(function (sel) {
        return sel.selected == true;
      })

      self.supportModel.relazionePep[index] = element.pep && element.pep.relazione.find(function (sel) {
        return sel.selected == true;
      })

      self.supportModel.originePatrimonio[index] = element.pep && element.pep.origineFondi.find(function (sel) {
        return sel.selected == true;
      })
    })

    // set default value new fiducianti
    self.newFiduciariAdded && self.newFiduciariAdded.forEach(function (element, index) {
      self.supportNewFiduciarioAdded.caricaIstituzionale[index] = element.pep && element.pep.carica.find(function (sel) {
        return sel.selected == true;
      })

      self.supportNewFiduciarioAdded.relazionePep[index] = element.pep && element.pep.relazione.find(function (sel) {
        return sel.selected == true;
      })

      self.supportNewFiduciarioAdded.originePatrimonio[index] = element.pep && element.pep.origineFondi.find(function (sel) {
        return sel.selected == true;
      })
    })

  }

  self.searchFiduciante = function () {
    self.enableModalSearch = true;
    self.supportTitModel = {}
    $("#footerInstant").css("z-index", "-1");
    $('.financial-leasing__footer').css("z-index", "-1");
    $timeout(function () {
      $modalService.openModal('ricercaFiducianti-modal');

    }, 200)


  }

  self.closeModal = function () {
    $modalService.closeModal('ricercaFiducianti-modal');
    self.enableModalSearch = false;
  }
  self.closeModalUploadDocument = function () {
    $modalService.closeModal('modalUploadDocument');
    self.enableModalDocument = false;
    self.fiducianteIesimo = Object.assign({});
    self.documentUpload = [];
    validateComponent();
  }

  self.addFidSearch = function (user) {
    $rootScope.disableDoubleClick = true;
    self.newFiduciariAdded = self.newFiduciariAdded && self.newFiduciariAdded.filter(function (esecutore) {
      return esecutore.cf != null;
    })
    self.enableLoaderButton = true;
    $financialApiService
      .getSearchRiUserG(user)
      .then(function (listAppCustomer) {
        if (listAppCustomer.success) {
          listAppCustomer.appCustomerUser.metadata.riUserG.sedeLegale.stato = listAppCustomer.appCustomerUser.metadata.riUserG.sedeLegale.statoEsteso
          if (listAppCustomer.appCustomerUser.metadata.riUserG.isEstero) {
            var codCityOfBirth = self.listaNazioni.find(function (element) {
              return element.name.toUpperCase() == listAppCustomer.appCustomerUser.metadata.riUserG.datiNascita.nazione.toUpperCase()
            }).value
            if (!listAppCustomer.appCustomerUser.metadata.riUserG.sesso) {
              listAppCustomer.appCustomerUser.metadata.riUserG.sesso = "m"
            }
            listAppCustomer.appCustomerUser.metadata.riUserG.cf = validationService.createCf(listAppCustomer.appCustomerUser.metadata.riUserG.nome, listAppCustomer.appCustomerUser.metadata.riUserG.cognome, listAppCustomer.appCustomerUser.metadata.riUserG.datiNascita.data, listAppCustomer.appCustomerUser.metadata.riUserG.sesso, codCityOfBirth)
          }
          // controllo se il cf è già presente in mappa
          var testExecutAdded = self.newFiduciariAdded && self.newFiduciariAdded.some(function (element) {
            return element.cf.toUpperCase() == listAppCustomer.appCustomerUser.metadata.riUserG.cf.toUpperCase()
          })
          var testExecut = self.model && self.model.some(function (element) {
            return element.cf.toUpperCase() == listAppCustomer.appCustomerUser.metadata.riUserG.cf.toUpperCase()
          })
          if (testExecutAdded || testExecut) {
            $rootScope.$broadcast("addAlert", {
              text: "ALREADY_ADDED"
            });
            $rootScope.disableDoubleClick = false;
            self.enableLoaderButton = false;
            return
          }
          var newUser = convertDateToFid(listAppCustomer.appCustomerUser.metadata.riUserG)
          var newTit = createNewFiduciario(newUser);
          self.model.push(newTit);
          createListForNewFid();
          validateComponent();
        }
        $rootScope.disableDoubleClick = false;
        $modalService.closeModal('ricercaFiducianti-modal');
        self.enableModalSearch = false;
        self.enableLoaderButton = false;
      })
      .catch(function (error) {
        console.log(error);
        $rootScope.disableDoubleClick = false;
        $modalService.closeModal('ricercaFiducianti-modal');
        self.enableModalSearch = false;
        self.enableLoaderButton = false;
      })
  }

  self.enabledConfirm = function (value) {
    self.enabledConfirmButton = !!value;
    self.userSelected = value;
  }

  var convertDateToFid = function (user) {
    var temp = {
      nome: user.nome,
      cognome: user.cognome,
      cf: user.cf,
      data: user.datiNascita.data,
      datiNascita: user.datiNascita,
      sedeLegale: user.sedeLegale,
      ndg: user.ndg,
      domicilioDiverso: user.domicilioDiverso,
      domicilio: user.domicilio,
      isEstero: user.isEstero,
      documento: user.documento
    }

    return temp;

  }

  var checkIfFiduciariIsPresent = function (cf) {
    var testModel = self.model.some(function (element) {
      return element.cf.toUpperCase() == cf.toUpperCase();
    })

    var testNewAdd = self.newFiduciariAdded.slice(0, (self.newFiduciariAdded.length - 1))
      .some(function (element) {
        return element.cf.toUpperCase() == cf.toUpperCase();
      })

    if (testModel || testNewAdd) {
      $rootScope.$broadcast("addAlert", {
        text: "ALREADY_ADDED"
      });
      self.newFiduciariAdded.pop();

      return true;
    }

    return false;

  }

  self.fieldChanges = function (campo, valore, indice) {
    if (valore && valore.stato && valore.stato.name && valore.stato.name.toUpperCase() != 'ITALIA' && valore.stato.name.toUpperCase() != "CAMPIONE D'ITALIA") {
      self.cfIsNotRequired[indice] = true;
      self.newFiduciariAdded[indice].isEstero = true;
    } else {
      self.newFiduciariAdded[indice].isEstero = false;
      self.cfIsNotRequired[indice] = false;
    }
    calculateFakeCf(indice);
    validateComponent();
  }

  var dealerUser = function () {
    if ($portalService.isAru()) {

      $userService.getDealerUser()
        .then(function (dealer) {
          if (dealer) {
            self.dealerUser = dealer;
          }
        });
    }
  }

  self.openModalDocument = function (fiduciante) {
    if (!fiduciante.cf && fiduciante.isEstero) {
      var codCityOfBirth = self.listaNazioni.find(function (element) {
        return element.name.toUpperCase() == fiduciante.datiNascita.nazione.toUpperCase()
      }).value
      fiduciante.sesso = "m";
      fiduciante.cf = validationService.createCf(fiduciante.nome, fiduciante.cognome, fiduciante.data, fiduciante.sesso, codCityOfBirth)

    }
    self.fiducianteIesimo = fiduciante;
    self.enableModalDocument = true;
    if (self.fiducianteIesimo.documento.idImgDocumentoFront) {
      var temp = {
        name: '',
        type: "imgDocument",
        selected: false,
        side: "front",
        typeDocument: self.fiducianteIesimo.documento.tipo,
        downloadLink: "",
        cdDoc: self.fiducianteIesimo.documento.tipo,
        id: self.fiducianteIesimo.documento.idImgDocumentoFront,
        imgDocumentoFront: self.fiducianteIesimo.documento.imgDocumentoFront,
        downloadKey: self.fiducianteIesimo.documento.idImgDocumentoFront
      };
      self.documentUpload.push(temp);
    }

    if (self.fiducianteIesimo.documento.idImgDocumentoBack) {
      var temp = {
        name: '',
        type: "imgDocument",
        selected: false,
        side: "back",
        typeDocument: self.fiducianteIesimo.documento.tipo,
        downloadLink: "",
        cdDoc: self.fiducianteIesimo.documento.tipo,
        id: self.fiducianteIesimo.documento.idImgDocumentoBack,
        imgDocumentoFront: self.fiducianteIesimo.documento.imgDocumentoBack,
        downloadKey: self.fiducianteIesimo.documento.idImgDocumentoBack
      };
      self.documentUpload.push(temp);
    }

    $timeout(function () {
      $modalService.openModal('modalUploadDocument')
    }, 300)
  }

  /* inizio sezione per caricamento documenti */
  self.changeUploadMode = function () {
    self.fiducianteIesimo.documento.idImgDocumentoFront = "";
    self.fiducianteIesimo.documento.idImgDocumentoBack = "";
    self.documentUpload = [];

  }
  self.callStartMobile = function () {
    if (self.uploadDocumentSelect == 'smartphone') {
      self.startUploadDocumentMobile();
    } else {
      self.startUploadDocument();
    }

  };

  self.uploader = new FileUploader({
    url: "",
    headers: {
      "Access-Control-Allow-Origin": "*",
      Token: "Bearer " + ($configService.getAppConfig().token || "no-token"),
      "App-Name": $rootScope.portalName,
    },
  });

  self.uploadDataFunc = function (item, index, privacy, type, side) {
    var document =
      arguments.length > 3 && arguments[3] !== undefined ?
        arguments[3] :
        false;
    if (item) {
      self.uploadData = item;
    }
    self.typeTempDocument = type;
    self.isPrivacyUpload = privacy;
    self.uploadDocumenti = document;
    self.currentCodeTypeNameIndex = index;
    self.sideUploaded = side;
  };
  self.finalUpload = function (item) {
    console.log("calling finalUpload");
    var url =
      $configService.getAppConfig().url +
      "/uni/upload/service-infos///FINANCIAL_PD";

    for (var int = 0; int < self.uploader.queue.length; int++) {
      self.uploader.queue[int].url = url;
    }
    var fileFront = document.querySelector(
      "#uploadInput_front").files[0];
    var fileBack = document.querySelector(
      "#uploadInput_back").files[0];
    var file;
    if (fileFront) {
      file = fileFront;
    } else {
      file = fileBack;
    }
    var tipo = self.fiducianteIesimo.documento.tipo;
    var reader = new FileReader();
    var fronte = self.sideUploaded == "front" ? true : false;
    reader.onload = function (event) {
      var formData = new FormData();
      jQuery("#uploadInput_front").val("");
      jQuery("#uploadInput_back").val("");
      appendToForm(formData, "file", file);
      appendToForm(formData, "type", "GENERAL_PERSONAL_DOCUMENTS");
      appendToForm(formData, "cdDoc", tipo);
      appendToForm(formData, "filename", file.name);
      appendToForm(formData, "idPratica", self.startQuestionario.id);
      appendToForm(formData, "personal", true);
      appendToForm(formData, "fronte", fronte);
      appendToForm(formData, "cfSoggetto", self.fiducianteIesimo.cf);
      appendToForm(formData, "ndgSoggetto", self.fiducianteIesimo.ndg);

      $uniService
        .uploadDocOnAdv(formData)
        .then(function (response) {
          if (!response.success) {
            self.visualProgBarDoc = false;
            self.disabledForUploadingInProgress = false;
            if (self.sideUploaded == "front") {
              self.disabeldUploadFront = false;
            } else {
              self.disabeldUploadBack = false;
            }
            $rootScope.$broadcast("addAlert", {
              text: "ERROR_UPLOAD"
            });

            return;
          }

          $timeout(function () {
            var temp = {
              name: file.name,
              type: "imgDocument",
              selected: false,
              side: self.sideUploaded,
              typeDocument: self.fiducianteIesimo.documento.tipo,
              downloadLink: "",
              cdDoc: self.fiducianteIesimo.documento.tipo,
              id: response.id,
              imgDocumentoFront: response.downloadKey,
              downloadKey: response.downloadKey
            };


            if (self.sideUploaded == "front") {
              self.disabeldUploadFront = true;
            } else {
              self.disabeldUploadBack = true;
            }

            self.documentUpload.push(temp);

            self.documentUpload = self.documentUpload.filter(function (
              elem
            ) {
              return elem.name != "";
            });
            self.disableInput = false;

            self.visualProgBarDoc = false;
            if (self.sideUploaded == "front") {

              self.fiducianteIesimo.documento.idImgDocumentoFront = response.downloadKey

            } else {
              self.fiducianteIesimo.documento.idImgDocumentoBack = response.downloadKey

            }

            $timeout(function () {
              self.disabledForUploadingInProgress = false;
            }, 1000);
          }, 40);
        })
        .catch(function (error) {
          self.visualProgBarDoc = false;
          self.disabledForUploadingInProgress = false;
          if (self.sideUploaded == "front") {
            self.disabeldUploadFront = false;
          } else {
            self.disabeldUploadBack = false;
          }
        });

    };
    if (file) {
      reader.readAsArrayBuffer(file);
    }
  };
  self.uploader.onAfterAddingFile = function (fileItem) {
    self.disabledForUploadingInProgress = true;
    console.log("fileItem", fileItem);
    self.progresso = 0;
    if (fileItem.file.size > 26214400) {
      $rootScope.$broadcast("addAlert", {
        text: "MAXIMUM_FILE_SIZE_EXCEEDED",
      });
      fileItem.remove();
      jQuery("#uploadInput_back").val("");
      jQuery("#uploadInput_front").val("");
    }
    var fileName = fileItem.file.name;
    if (
      fileName.toLowerCase().indexOf(".png") > -1 ||
      fileName.toLowerCase().indexOf(".jpg") > -1 ||
      fileName.toLowerCase().indexOf(".jpeg") > -1 ||
      fileName.toLowerCase().indexOf(".tiff") > -1 ||
      fileName.toLowerCase().indexOf(".pdf") > -1 ||
      fileName.toLowerCase().indexOf(".zip") > -1
    ) {
      self.uploader.queue[0].progress = 100;

      self.visualProgBarDoc = true;

      $timeout(function () {
        self.progresso = 100;
      }, 500);
    } else {
      fileItem.remove();
      jQuery("#uploadInput_back").val("");
      jQuery("#uploadInput_front").val("");
      $rootScope.$broadcast("addAlert", {
        text: "FORMAT_NOT_SUPPORTED",
      });
      self.disabledForUploadingInProgress = false;
    }
  };

  self.uploader.onAfterAddingAll = function (addedFileItems) {
    console.info("onAfterAddingAll", addedFileItems);
    self.finalUpload(self.uploadData);
  };

  self.uploader.onBeforeUploadItem = function (item) {
    item.file.name = window.encodeURIComponent(item.file.name);
    item.headers["Token"] = "Bearer " + $configService.getAppConfig().token;
    self.disableInput = true;
  };

  self.uploader.onProgressItem = function (fileItem, progress) {
    self.uploadCompleted = false;
  };

  self.uploader.onProgressAll = function (progress) { };

  self.uploader.onSuccessItem = function (
    fileItem,
    response,
    status,
    headers
  ) { };

  self.uploader.onErrorItem = function (
    fileItem,
    response,
    status,
    headers
  ) {
    console.info("onErrorItem", fileItem, response, status, headers);
    jQuery("#uploadInput_back").val("");
    jQuery("#uploadInput_front").val("");
    $rootScope.$broadcast("addAlert", {
      text: "ERROR_UPLOADING_FILE",
    });

    self.disableInput = false;
    $timeout(function () {
      self.visualProgBarDoc = false;
    }, 4000);

    fileItem.remove();
    jQuery("#uploadInput_back").val("");
    jQuery("#uploadInput_front").val("");
  };

  self.uploader.onCancelItem = function (
    fileItem,
    response,
    status,
    headers
  ) {
    console.log(status);
  };

  self.uploader.onCompleteItem = function (
    fileItem,
    response,
    status,
    headers
  ) {
    console.info("onCompleteItem", fileItem, response, status, headers);
    if (
      response &&
      response.uploadFileServicePojo &&
      response.uploadFileServicePojo.success
    ) {

    }
    self.uploader.queue = [];

    self.disableInput = false;
    $timeout(function () {
      self.visualProgBarDoc = false;

      self.disabledForUploadingInProgress = false;
    }, 4000);
    jQuery("#uploadInput_back").val("");
    jQuery("#uploadInput_front").val("");
  };

  self.uploader.onCompleteAll = function () {
    console.info("onCompleteAll");
    self.uploadCompleted = true;
  };

  self.uploader.onSuccessItem = function (
    fileItem,
    response,
    status,
    headers
  ) {
    self.uploading = false;
  };

  self.check = function (el) {
    el.selected = !el.selected;
  };

  self.trashCanEnabledDoc = function () {
    return self.documentUpload.some(function (element) {
      return element.selected == true;
    })
  }

  self.deletePrivacyDocument = function () {
    self.progresso = 100;

    self.visualProgBarDoc = true;
    var temp = self.documentUpload;
    temp.forEach(function (element) {
      $simulationService
        .deleteChecklistFileAdv(element.id)
        .then(function (response) {
          console.log(response);
          self.progresso = 0;
          if (response.success) {
            self.documentUpload = [];

            if (element.side == 'front') {
              self.fiducianteIesimo.documento.idImgDocumentoFront = ""
              self.disabeldUploadFront = false;
            } else {
              self.fiducianteIesimo.documento.idImgDocumentoBack = ""
              self.disabeldUploadBack = false;
            }

            self.uploadOk = false;
          }
          self.visualProgBarDoc = false;
        })
        .catch(function (error) {
          $rootScope.$broadcast("addAlert", {
            text: "ERROR_TEC",
          });
        });

    });
  }

  self.downloadFiles = function (file) {
    var url = "/uni/downloadDocAdv/service-infos/";
    if (!self.startQuestionario.readOnly) {
      var input = {
        downloadKey: file.downloadKey
      }
    } else {
      var input = {
        downloadKey: file
      }
    }
    $download.getGenericDownload(url, input)
      .then(function (response) {
        console.log(response)
      })
  }

  self.startUploadDocument = function () {
    self.enableLoader = true;
    $rootScope.$broadcast("pageLoader", {
      action: "OPEN",
    });
    var person = {
      cf: self.fiducianteIesimo.cf,
      nome: self.fiducianteIesimo.nome && self.fiducianteIesimo.nome.toUpperCase(),
      cognome: self.fiducianteIesimo.cognome &&
        self.fiducianteIesimo.cognome.toUpperCase(),
      telefono: self.dealerUser.tel,
      documento: {
        tipo: self.fiducianteIesimo.documento.tipo,
      },
    };

    self.intervalOfRepeatListenMobileCapture = 0;
    var numberOfIteration = 0;
    var person = [Pf.build(person)];


    $financialApiService
      .startMobileCaptureAdv(
        person,
        self.vendorPhone,
        false,
        self.startQuestionario.id,
        self.fiducianteIesimo.cf,
        self.startQuestionario.metadataAdv.cliente.common.cf
      )
      .then(function (response) {
        if (response.success) {
          var inputListenMobileCapture = {
            id: response.id,
          };

          var inputForCallBackMobileCapture = {
            id: response.id,
            contingencyUpload: self.documentUpload,
            flagCallFE: "false"
          };

          $instantService
            .callbackMobileCapture(inputForCallBackMobileCapture)
            .then(function (response) {
              if (!response.success) {
                $rootScope.$broadcast("pageLoader", {
                  action: "CLOSE",
                });
              } else {
                self.intervalOfRepeatListenMobileCapture = setInterval(
                  function () {
                    $instantService
                      .listenMobileCapture(inputListenMobileCapture)
                      .then(function (response) {
                        numberOfIteration++;
                        if (
                          response.success &&
                          response.details.uploadCompleted
                        ) {
                          clearInterval(
                            self.intervalOfRepeatListenMobileCapture
                          );
                          self.enableLoader = false;
                          $rootScope.$broadcast("pageLoader", {
                            action: "CLOSE",
                          });
                          /* uno */

                          self.fiducianteIesimo.documento.dataRilascio = self.fiducianteIesimo.documento.dataRilascio ? self.fiducianteIesimo.documento.dataRilascio : response.ocrResponse.documento.dataRilascio;
                          self.fiducianteIesimo.documento.dataScadenza = self.fiducianteIesimo.documento.dataScadenza ? self.fiducianteIesimo.documento.dataScadenza : response.ocrResponse.documento.dataScadenza;
                          self.fiducianteIesimo.documento.luogoEsteso = self.fiducianteIesimo.documento.luogoEsteso ? self.fiducianteIesimo.documento.luogoEsteso : response.ocrResponse.documento.luogoEsteso;
                          self.fiducianteIesimo.documento.enteRilascio.name = self.fiducianteIesimo.documento.enteRilascio.name ? self.fiducianteIesimo.documento.enteRilascio.name : response.ocrResponse.documento.enteRilascio && response.ocrResponse.documento.enteRilascio.name;
                          self.fiducianteIesimo.documento.provincia = self.fiducianteIesimo.documento.provincia ? self.fiducianteIesimo.documento.provincia : response.ocrResponse.documento.provincia;
                          self.fiducianteIesimo.documento.numero = self.fiducianteIesimo.documento.numero ? self.fiducianteIesimo.documento.numero : response.ocrResponse.documento.numero;

                          $rootScope.$broadcast("addAlert", {
                            text: "MSG_SEND_FILE_OK"
                          });
                          self.fiducianteIesimo.documento.docSubmitted = true;
                          self.closeModalUploadDocument();

                        }
                        if (numberOfIteration >= 50) {
                          self.enableLoader = false;
                          $rootScope.$broadcast("pageLoader", {
                            action: "CLOSE"
                          });

                          $rootScope.$broadcast("addAlert", {
                            text: "ERROR_TIMEOUT_LISTEN_MOBILE"
                          });

                          clearInterval(
                            self.intervalOfRepeatListenMobileCapture
                          );
                        }
                        console.log(
                          "Numero di iterazioni",
                          numberOfIteration
                        );
                        response.ocrResponse.documento.luogoEsteso &&
                          self.upgradeList({
                            comune: self.fiducianteIesimo.documento.luogoEsteso.nome,
                          });
                      })
                      .catch(function (error) {
                        console.log(error);
                        self.enableLoader = false;
                        $rootScope.$broadcast("pageLoader", {
                          action: "CLOSE",
                        });
                      });
                  },
                  10000
                );
              }
            })
            .catch(function (error) {
              console.log(error);
              self.enableLoader = false;
              $rootScope.$broadcast("pageLoader", {
                action: "CLOSE",
              });

              $rootScope.$broadcast("addAlert", {
                text: "ERROR_TIMEOUT_LISTEN_MOBILE",
              });
            });
        } else {
          $rootScope.$broadcast("pageLoader", {
            action: "CLOSE",
          });
        }
      })
      .catch(function (error) {
        console.log(error);
        self.showLoader = false;
        $rootScope.$broadcast("pageLoader", {
          action: "CLOSE",
        });
      });


  };

  self.startUploadDocumentMobile = function () {
    self.enableLoader = true;
    $rootScope.$broadcast("pageLoader", {
      action: "OPEN",
    });
    self.documentUpload = [];
    var person = {
      cf: self.fiducianteIesimo.cf,
      nome: self.fiducianteIesimo.nome && self.fiducianteIesimo.nome.toUpperCase(),
      cognome: self.fiducianteIesimo.cognome &&
        self.fiducianteIesimo.cognome.toUpperCase(),
      telefono: self.dealerUser.tel,
      documento: {
        tipo: self.fiducianteIesimo.documento.tipo,
      },
    };

    self.intervalOfRepeatListenMobileCapture = 0;
    var numberOfIteration = 0;
    var person = [Pf.build(person)];
    var listOfDocument = [{
      id: "imgDocument",
      order: 2,
      fronteRetro: true,
      documentType: null,
      labelName: null,
      labelDescription: null,
      label: "DOC_IDENTITA_LBL",
      mocaDocumentTypes: [
        "identita-fronte",
        "identita-retro"
      ]
    }]
    $financialApiService
      .startMobileCaptureAdv(
        person,
        self.vendorPhone,
        true,
        self.startQuestionario.id,
        self.fiducianteIesimo.cf,
        self.startQuestionario.metadataAdv.cliente.common.cf,
        listOfDocument
      )
      .then(function (response) {
        if (response.success) {
          var inputListenMobileCapture = {
            id: response.id,
          };

          self.intervalOfRepeatListenMobileCapture = setInterval(
            function () {
              $instantService
                .listenMobileCapture(inputListenMobileCapture)
                .then(function (response) {
                  numberOfIteration++;
                  if (
                    response.success &&
                    response.details.uploadCompleted
                  ) {
                    clearInterval(self.intervalOfRepeatListenMobileCapture);
                    self.enableLoader = false;
                    $rootScope.$broadcast("pageLoader", {
                      action: "CLOSE",
                    });
                    self.fiducianteIesimo.documento.dataRilascio = self.fiducianteIesimo.documento.dataRilascio ? self.fiducianteIesimo.documento.dataRilascio : response.ocrResponse.documento.dataRilascio;
                    self.fiducianteIesimo.documento.dataScadenza = self.fiducianteIesimo.documento.dataScadenza ? self.fiducianteIesimo.documento.dataScadenza : response.ocrResponse.documento.dataScadenza;
                    self.fiducianteIesimo.documento.luogoEsteso = self.fiducianteIesimo.documento.luogoEsteso ? self.fiducianteIesimo.documento.luogoEsteso : response.ocrResponse.documento.luogoEsteso;
                    self.fiducianteIesimo.documento.enteRilascio.name = self.fiducianteIesimo.documento.enteRilascio.name ? self.fiducianteIesimo.documento.enteRilascio.name : response.ocrResponse.documento.enteRilascio && response.ocrResponse.documento.enteRilascio.name;
                    self.fiducianteIesimo.documento.provincia = self.fiducianteIesimo.documento.provincia ? self.fiducianteIesimo.documento.provincia : response.ocrResponse.documento.provincia;
                    self.fiducianteIesimo.documento.numero = self.fiducianteIesimo.documento.numero ? self.fiducianteIesimo.documento.numero : response.ocrResponse.documento.numero;
                    self.documentUpload = [];
                    var temp = {
                      name: response.ocrResponse.documento.imgDocumentoFront,
                      type: "imgDocument",
                      selected: false,
                      side: "front",
                      typeDocument: self.fiducianteIesimo.documento.tipo,
                      cdDoc: self.fiducianteIesimo.documento.tipo,
                      id: response.ocrResponse.documento.idImgDocumentoFront,
                      downloadKey: response.ocrResponse.documento.idImgDocumentoFront
                    };

                    self.documentUpload.push(temp);
                    var temp = {
                      name: response.ocrResponse.documento.imgDocumentoBack,
                      type: "imgDocument",
                      selected: false,
                      side: "back",
                      typeDocument: self.fiducianteIesimo.documento.tipo,
                      cdDoc: self.fiducianteIesimo.documento.tipo,
                      id: response.ocrResponse.documento.idImgDocumentoBack,
                      downloadKey: response.ocrResponse.documento.idImgDocumentoBack
                    };
                    self.documentUpload.push(temp);
                    self.fiducianteIesimo.documento.imgDocumentoBack = response.ocrResponse.documento.imgDocumentoBack;
                    self.fiducianteIesimo.documento.imgDocumentoFront = response.ocrResponse.documento.imgDocumentoFront;
                    self.fiducianteIesimo.documento.idImgDocumentoFront = response.ocrResponse.documento.idImgDocumentoFront;
                    self.fiducianteIesimo.documento.idImgDocumentoBack = response.ocrResponse.documento.idImgDocumentoBack;
                    $rootScope.$broadcast("addAlert", {
                      text: "MSG_SEND_FILE_OK"
                    });
                    self.fiducianteIesimo.documento.docSubmitted = true;
                    self.closeModalUploadDocument();
                  }
                  if (numberOfIteration >= 50) {
                    self.enableLoader = false;
                    $rootScope.$broadcast("pageLoader", {
                      action: "CLOSE",
                    });

                    $rootScope.$broadcast("addAlert", {
                      text: "ERROR_TIMEOUT_LISTEN_MOBILE",
                    });

                    clearInterval(self.intervalOfRepeatListenMobileCapture);
                  }
                  console.log("Numero di iterazioni", numberOfIteration);
                  response.ocrResponse &&
                    self.upgradeList({
                      comune: self.fiducianteIesimo.documento.luogoEsteso.nome,
                    });
                })
                .catch(function (error) {
                  console.log(error);
                  self.enableLoader = false;
                  $rootScope.$broadcast("pageLoader", {
                    action: "CLOSE",
                  });
                });
            },
            10000
          );
        } else {
          $rootScope.$broadcast("pageLoader", {
            action: "CLOSE",
          });
        }
      })
      .catch(function (error) {
        console.log(error);
        self.showLoader = false;
        self.enableLoader = false;
        $rootScope.$broadcast("pageLoader", {
          action: "CLOSE",
        });
      });


  };



  /* fine sezione caricamento documenti */

  self.riabilita = function (index) {
    self.model[index].riattivatoFe = true;
    self.model[index].annullatoFe = false;
    validateComponent();
  }


  self.annulla = function (index) {
    self.model[index].annullatoFe = true;
    self.model[index].riattivatoFe = false;
    validateComponent();
  }

  var calculateFakeCf = function (indice) {
    if (self.newFiduciariAdded[indice] && !self.newFiduciariAdded[indice].cf && self.newFiduciariAdded[indice].nome && self.newFiduciariAdded[indice].cognome && self.newFiduciariAdded[indice].sesso && self.newFiduciariAdded[indice].datiNascita.nazione && self.newFiduciariAdded[indice].data && self.newFiduciariAdded[indice].isEstero) {
      var codCityOfBirth = self.listaNazioni.find(function (element) {
        return element.name.toUpperCase() == self.newFiduciariAdded[indice].datiNascita.nazione.toUpperCase()
      }).value
      self.newFiduciariAdded[indice].cf = validationService.createCf(self.newFiduciariAdded[indice].nome, self.newFiduciariAdded[indice].cognome, self.newFiduciariAdded[indice].data, self.newFiduciariAdded[indice].sesso, codCityOfBirth)
      self.verifyDate(indice);
    }
  }

  var createListForNewFid = function () {
    var indice = self.model.length - 1;

    self.listaNomeRilascio[indice] = Documento.getEntiRilascio(
      self.model[indice].documento.tipo
    );

    self.listaNomeComuniRilascio[indice] = self.mapComuni
      .filter(function (comune) {
        return comune.sigla == self.model[indice].documento.provincia;
      });
  }

  var ricreaModelli = function () {
    self.newFiduciariAdded = self.model.filter(function (element) {
      return !element.ndg
    });
    self.newFiduciariAdded.forEach(function (element, index) {
      self.listaComuniNascita[index] = self.mapComuni
        .filter(function (comune) {
          return comune.sigla == element.datiNascita.provincia;
        });
      self.listaNomeRilascioNew[index] = element.documento && element.documento.tipo && Documento.getEntiRilascio(
        element.documento.tipo
      );
      if (element.datiNascita.provincia && element.datiNascita.provincia.toUpperCase() != 'EE' && element.datiNascita.provincia.toUpperCase() != 'SE') {
        self.creaComuni(index, element.documento.provincia, true);
        self.verifyDate(index, true)
      }
    })
    self.model = self.model.filter(function (element) {
      return element.ndg
    });
    self.model && self.model.forEach(function (element, index) {
      if (element && !element.documento) {
        element.documento = Documento.build();
      }
      self.listaNomeRilascio[index] = element.documento && element.documento.tipo && Documento.getEntiRilascio(
        element.documento.tipo
      );
      if (element && element.sedeLegale && element.sedeLegale.stato) {
        element.sedeLegale.stato.name = element.sedeLegale.stato.name && element.sedeLegale.stato.name.toUpperCase();
      }
      self.creaComuni(index, element.documento.provincia);
    })
  }

  self.validatingComponent = function () {
    var testComponentValid = self.model && self.model.length && self.model
      .filter(tit => {
        return !tit.annullato && !tit.annullatoFe;
      })
      .every(x => {
        return x.isOk == true;
      })
    console.log("Il form fiducianti è:", testComponentValid);
    self.exportValidationComponent({
      valid: testComponentValid
    })
  }

}